import React from "react";


const FieldLabel = ({id, label, tooltip}) => {
  return (
    <label className="form-input__label" htmlFor={id}>
      {label && <span className="form-input__label-content">{label}</span>}
      {tooltip && <span style={{pointerEvents: "auto"}}>{tooltip}</span>}
    </label>
  );
};


export default FieldLabel;
